import { resources } from "@constants/hardcoded-strings";
import { formatPolicyComponent } from "@formatters/policy-component-details/policy-component-details-formatter";
import { AxnAttributeTypeField } from "@idw-types/data/reference-data/axn";
import { FormattedPolicyComponent, PolicyComponent } from "@idw-types/data/reference-data/generic/policy-component";
import { setPolicyComponentDetails } from "@redux/actions/policy-component-details-actions";
import { updatePolicyComponentRequest } from "@requests/service-configuration/update-policy-component-request";
import { displaySuccessModal, logAndDisplayErrorModal } from "@utils/app-alert-util";
import { getPolicyComponent } from "@utils/policies/policy-component-util";
import cloneDeep from "lodash/cloneDeep";
import { Dispatch } from "redux";

export const updatePolicyComponentReduxRequest = (dispatch: Dispatch) => async (
    formattedPolicyComponent: FormattedPolicyComponent,
    axnAttributeTypeFields: Array<AxnAttributeTypeField>
): Promise<PolicyComponent> => {
    const policyComponent = getPolicyComponent(cloneDeep(formattedPolicyComponent));
    const { data, error, body } = await updatePolicyComponentRequest(policyComponent);
    if (data?.transferObject) {
        displaySuccessModal(
            dispatch,
            resources.requests.updatePolicyComponent.success.title,
            resources.requests.updatePolicyComponent.success.message
        );

        const formattedPolicyComponent = formatPolicyComponent(
            data.transferObject,
            axnAttributeTypeFields
        );
        dispatch(setPolicyComponentDetails({
            ...formattedPolicyComponent,
            permissions: policyComponent.permissions
        }));

        return data.transferObject;
    } else {
        if (error) {
            logAndDisplayErrorModal(
                dispatch,
                error,
                resources.requests.updatePolicyComponent.error.title,
                resources.requests.updatePolicyComponent.error.message,
                error,
                null,
                body
            );
        }
    }

    return null;

};